import { IconCreditCardFilled } from '@iwoca/icons';
import Skeleton from 'react-loading-skeleton';

import { usePaymentMethodCard } from '../../../../../hooks/usePaymentMethod';

export const PaymentMethodSubTitle = () => {
  const { lastFourDigits, expiryDate, isLoading } = usePaymentMethodCard();

  if (isLoading) return <Skeleton containerTestId="loading-skeleton" />;

  return (
    lastFourDigits &&
    expiryDate && (
      <div className="flex items-center gap-s text-xs font-med text-structure-40">
        <IconCreditCardFilled className="m-0" />
        <p className="m-0">**** **** **** {lastFourDigits}</p>
        <p className="m-0">{expiryDate}</p>
      </div>
    )
  );
};
